/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Price_Ent_UnitInputs */

const en_mk_price_ent_unit = /** @type {(inputs: Mk_Price_Ent_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`custom pricing`)
};

const id_mk_price_ent_unit = /** @type {(inputs: Mk_Price_Ent_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`harga khusus`)
};

/**
* | output |
* | --- |
* | "custom pricing" |
*
* @param {Mk_Price_Ent_UnitInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_ent_unit = /** @type {((inputs?: Mk_Price_Ent_UnitInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_Ent_UnitInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_ent_unit(inputs)
	return en_mk_price_ent_unit(inputs)
});